import { useEffect, useState, PropsWithChildren } from 'react';

import { StatsigClient } from '@statsig/js-client';
import { StatsigProvider } from '@statsig/react-bindings';

import { STATSIG_CLIENT_ID, STATSIG_TIER_NAME } from '../../constants/statsig';

const StatsigCustomProvider = ({ children }: PropsWithChildren) => {
  const [statsigClient, setStatsigClient] = useState<StatsigClient | null>(null);
  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    const initializeStatsig = async () => {
      const client = new StatsigClient(
        STATSIG_CLIENT_ID,
        {},
        {
          environment: { tier: STATSIG_TIER_NAME }
        }
      );
      await client.initializeAsync();
      setStatsigClient(client);
      setIsInitializing(false);
    };

    if (!statsigClient) {
      initializeStatsig();
    }
  }, [statsigClient]);

  if (isInitializing || !statsigClient) {
    return <>{children}</>;
  }

  return <StatsigProvider client={statsigClient}>{children}</StatsigProvider>;
};

export default StatsigCustomProvider;
